import React from "react";
import { useStore } from "../../store/store";
import SlidingIconButton from "./SlidingIconButton";

interface ClearHistoryButtonProps {}

const ClearHistoryButton: React.FC<ClearHistoryButtonProps> = ({}) => {
  const { clearArtworkViewHistory } = useStore();
  const onClear = () => {
    clearArtworkViewHistory();
  };
  return (
    <SlidingIconButton
      color="text-white"
      text="Wis geschiedenis"
      iconClass="d-trash"
      className="w-[9.5rem] hover:border-sunsetCoral"
      onClick={onClear}
      openByDefault={true}
      reverse={false}
    />
  );
};

export default ClearHistoryButton;
